import React from 'react';
import Badge from '../ui/Badge';
import { thinTitle } from './seoThin';

/* "Thin" pill for a page or listing row; the reasons are in the tooltip and,
   for screen readers, in the accessible label. Renders nothing otherwise. */
export default function ThinBadge({ verdict }) {
  if (!verdict?.thin) return null;
  const title = thinTitle(verdict);
  return (
    <span aria-label={`Thin. ${title}`} style={{ cursor: 'help' }}>
      <Badge state="warn" title={title}>Thin</Badge>
    </span>
  );
}
